$shm_hitalama_components_parameters $mol_page
	definition $shm_hitalama_map_widget_entity_custom
	saving false
	save_error \
	removed? null
	title \Параметры
	minimal_width 480
	body /
		<= Settings $shm_hitalama_components_settings
			definition <= definition
			saving <= saving
			save_error <= save_error
			removed? <=> removed?
